import React, { useState, useEffect } from 'react';
import { getWisdomMoments } from '../../services/videoActivationAPI';
import WisdomMomentCard from './WisdomMomentCard';

const WisdomMomentsFeed = () => {
  const [moments, setMoments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWisdomMoments()
      .then(data => {
        const list = data.moments || data;
        setMoments(Array.isArray(list) ? list.slice(0, 4) : []);
      })
      .catch(() => setMoments([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ marginBottom: '10px' }}>
        <div style={{ height: '20px', background: '#eee', borderRadius: '4px',
          width: '140px', marginBottom: '10px', opacity: 0.5 }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          {[1, 2].map(i => (
            <div key={i} style={{ height: '100px', background: '#eee',
              borderRadius: '10px', opacity: 0.4 }} />
          ))}
        </div>
      </div>
    );
  }

  if (!moments.length) return null;

  return (
    <div style={{
      background: 'white',
      border: '0.5px solid #c8d89a',
      borderRadius: '10px',
      padding: '12px 14px',
      marginBottom: '10px',
    }}>
      {/* Section header */}
      <div style={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', marginBottom: '10px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="#556B2F">
            <path d="M8 2l1.5 3 3.5.5-2.5 2.5.6 3.5L8 10l-3.1 1.5.6-3.5L3 5.5l3.5-.5z"/>
          </svg>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#2a2a1a' }}>
            Wisdom moments
          </span>
        </div>
        <a href="/wisdom-moments" style={{
          fontSize: '12px', color: '#556B2F', textDecoration: 'none',
        }}>
          View all &rarr;
        </a>
      </div>

      {/* 2-column grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: '8px',
      }}>
        {moments.map(moment => (
          <WisdomMomentCard key={moment.id} moment={moment} />
        ))}
      </div>
    </div>
  );
};

export default WisdomMomentsFeed;
